import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchWrapper } from "../_helpers";
import { getStoredValue } from "../_helpers/storagehelper";

const name = "purchaseCredits";
const initialState = createInitialState();
const reducers = createReducers();
const extraActions = createExtraActions();

// const extraReducers = createExtraReducers();

const slice = createSlice({
  name,
  initialState,
  reducers,
  extraReducers: (builder) => {
    createExtraReducers(builder);
  },
  // extraReducers,
});

// exports

export const purchaseCreditsActions = { ...slice.actions, ...extraActions };
export const purchaseCreditsReducer = slice.reducer;

// implementation

function createInitialState() {
  return {
    error: null,
    CreateClientSecretDetailsResponse: [],
    CreateClientSecretDetails: [],
    UpdateStripePaymentDetails: [],
    LockDownStatus: null,
    InmateDetails1: {},
    InmateDetails1: {},
    GetPurchaseOrderTransactionInvoiceInfo: [],
    user: getStoredValue("user"),
  };
}
function createReducers() {
  return {
    clearEmailResponse,
    InmateDetails,
  };
  function clearEmailResponse(state) {
    state.CreateClientSecretDetails = [];
    state.CreateClientSecretDetails = [];
    state.PaymentTimeOut = [];
    state.user = null;
  }
  function InmateDetails(state, action) {
    state.InmateDetails1 = action?.payload;
  }
}

function createExtraActions() {
  const baseUrl = `${process.env.REACT_APP_API_URL}/PublicUser/PurchaseCredits`;
  const ManageUserbaseUrl = `${process.env.REACT_APP_API_URL}/ManagementUser/PublicUsers`;

  return {
    CreateClientSecretDetails: CreateClientSecretDetails(),
    UpdateStripePaymentDetails: UpdateStripePaymentDetails(),
    SendMailForFailedTransaction: SendMailForFailedTransaction(),
    LockdownPODRestriction: LockdownPODRestriction(),
    GetPurchaseOrderTransactionInvoiceInfo: GetPurchaseOrderTransactionInvoiceInfo(),
    PaymentSubmitClick: PaymentSubmitClick(),
    PaymentTimeOut: PaymentTimeOut(),
  };
  function CreateClientSecretDetails() {
    return createAsyncThunk(
      `${name}/CreateClientSecretDetails`,
      async (addFormData) =>
        await fetchWrapper.get(
          `${baseUrl}/CreateClientSecretDetails?emailid=${addFormData.emailid}&stripeRandomOrderID=${addFormData.stripeRandomOrderID}&inmateID=${addFormData.inmateID}&amount=${addFormData.amount}`
        )
    );
  }
  function UpdateStripePaymentDetails() {
    return createAsyncThunk(
      `${name}/UpdateStripePaymentDetails`,
      async (addFormData) =>
        await fetchWrapper.post(
          `${baseUrl}/UpdateStripePaymentDetails`,
          addFormData
        )
    );
  }

  function SendMailForFailedTransaction() {
    return createAsyncThunk(
      `${name}/SendMailForFailedTransaction`,
      async (addFormData) =>
        await fetchWrapper.post(
          `${baseUrl}/SendMailForFailedTransaction`,
          addFormData
        )
    );
  }

  // ------------------------- Lockdown Status - Check -------------------------
  function LockdownPODRestriction() {
    return createAsyncThunk(
      `${name}/LockdownPODRestriction`,
      async (addFormData) =>
        await fetchWrapper.post(
          `${baseUrl}/LockdownPODRestriction`,
          addFormData
        )
    );
  }
  function GetPurchaseOrderTransactionInvoiceInfo() {
    return createAsyncThunk(
      `${name}/GetPurchaseOrderTransactionInvoiceInfo`,
      async (addFormData) =>
        await fetchWrapper.get(
          `${baseUrl}/GetPurchaseOrderTransactionInvoiceInfo?publicUserId=${addFormData.publicUserId}&inmateID=${addFormData.inmateID}&pOTransactionRandomID=${addFormData.pOTransactionRandomID}`
        )
    );
  }
  function PaymentSubmitClick() {
    return createAsyncThunk(
      `${name}/PaymentSubmitClick`,
      async (addFormData) =>
        await fetchWrapper.post(`${baseUrl}/PaymentSubmitClick`, addFormData)
    );
  }

  function PaymentTimeOut() {
    return createAsyncThunk(
      `${name}/PaymentTimeOut`,
      async (addFormData) =>
        await fetchWrapper.post(`${ManageUserbaseUrl}/PurchaseOrderTransactionUpdateWeb`, addFormData)
    );
  }
}

function createExtraReducers(builder) {
  builder
    // Handle CreateClientSecretDetails
    .addCase(extraActions.CreateClientSecretDetails.pending, (state) => {
      state.error = null;
    })
    .addCase(
      extraActions.CreateClientSecretDetails.fulfilled,
      (state, action) => {
        state.CreateClientSecretDetails = [];
        state.CreateClientSecretDetails = action.payload;
      }
    )
    .addCase(
      extraActions.CreateClientSecretDetails.rejected,
      (state, action) => {
        state.error = action.error.message;
      }
    )

    // Handle UpdateStripePaymentDetails
    .addCase(extraActions.UpdateStripePaymentDetails.pending, (state) => {
      state.error = null;
    })
    .addCase(
      extraActions.UpdateStripePaymentDetails.fulfilled,
      (state, action) => {
        state.UpdateStripePaymentDetails = [];
        state.UpdateStripePaymentDetails = action.payload;
      }
    )
    .addCase(
      extraActions.UpdateStripePaymentDetails.rejected,
      (state, action) => {
        state.error = action.error.message;
      }
    )

    // Handle - Lockdown Response
    .addCase(extraActions.LockdownPODRestriction.pending, (state) => {
      state.error = null;
    })
    .addCase(
      extraActions.LockdownPODRestriction.fulfilled,
      (state, action) => {
        state.LockDownStatus = action.payload;
      }
    )
    .addCase(
      extraActions.LockdownPODRestriction.rejected,
      (state, action) => {
        state.error = action.error.message;
      }
    )
    // Handle GetPurchaseOrderTransactionInvoiceInfo
    .addCase(
      extraActions.GetPurchaseOrderTransactionInvoiceInfo.pending,
      (state) => {
        state.error = null;
      }
    )
    .addCase(
      extraActions.GetPurchaseOrderTransactionInvoiceInfo.fulfilled,
      (state, action) => {
        state.GetPurchaseOrderTransactionInvoiceInfo = [];
        state.GetPurchaseOrderTransactionInvoiceInfo = action.payload;
      }
    )
    .addCase(
      extraActions.GetPurchaseOrderTransactionInvoiceInfo.rejected,
      (state, action) => {
        state.error = action.error.message;
      }
    )
    // HandlePaymentSubmitClick
    .addCase(extraActions.PaymentSubmitClick.pending, (state) => {
      state.error = null;
    })
    .addCase(extraActions.PaymentSubmitClick.fulfilled, (state, action) => {
      state.PaymentSubmitClick = [];
      state.PaymentSubmitClick = action.payload;
    })
    .addCase(extraActions.PaymentSubmitClick.rejected, (state, action) => {
      state.error = action.error.message;
    })


    // Stripe Time out
    .addCase(extraActions.PaymentTimeOut.pending, (state) => {
      state.error = null;
    })
    .addCase(extraActions.PaymentTimeOut.fulfilled, (state, action) => {
      state.PaymentTimeOut = [];
      state.PaymentTimeOut = action.payload;
    })
    .addCase(extraActions.PaymentTimeOut.rejected, (state, action) => {
      state.error = action.error.message;
    });
}
